//import App from './App'
import ticketIcon from '../resources/noun-tickets-2188850.png'
import overOnsIcon from '../resources/noun-about-us-4181324.png'
import '../stylesheets/Home.css'

function Home()
{
    return (
        <>
            <Body />
            <Footer />
        </>
    )
}

function Body()
{
    return (
        <>
        <div className='demo'>
            <SlideshowContainer/>
            <ButtonSection />
        </div>
        </>
    )
}

function SlideshowContainer()
{
    return (
        <>
            <div className='slideshow_container'>
                <div className='slideshow'></div>
            </div>
        </>
    )
}

function ButtonSection()
{
    return (
        <>
            <div className='buttonSection'>
                <img className='imageButton' id='imageButtonTickets' src= {ticketIcon} alt='Tickets'></img>
                <img className='imageButton' id='imageButtonOverOns' src= {overOnsIcon} alt='Over Ons'></img>
            </div>
        </>
    )
}

function Footer() 
{
    return (
        <><div className="footer">This will always appear at the bottom of the page, but <strong>not fixed</strong>.</div></>
    )
}

export default Home;